/**
 * コード体系は国土交通省の建設業者・宅建業者等企業情報検索システム[https://etsuran.mlit.go.jp/TAKKEN/takkenKensaku.do]を参考にした
 */
import prefecture from "./prefecture";
let licenceTypeList = [
  {code: 0, name: "国土交通大臣"},
];
prefecture.list.forEach(e => licenceTypeList.push({code: e.code, name: e.name + "知事"}));
licenceTypeList = licenceTypeList.concat([
  {code: 51, name: "北海道知事（石狩）"},
  {code: 52, name: "北海道知事（渡島）"},
  {code: 53, name: "北海道知事（檜山）"},
  {code: 54, name: "北海道知事（後志）"},
  {code: 55, name: "北海道知事（空知）"},
  {code: 56, name: "北海道知事（上川）"},
  {code: 57, name: "北海道知事（留萌）"},
  {code: 58, name: "北海道知事（宗谷）"},
  {code: 59, name: "北海道知事（オホ）"},
  {code: 60, name: "北海道知事（胆振）"},
  {code: 61, name: "北海道知事（日高）"},
  {code: 62, name: "北海道知事（十勝）"},
  {code: 63, name: "北海道知事（釧路）"},
  {code: 64, name: "北海道知事（根室）"},
]);

const licenceUpdateCount = [
    {"value": null, "text": "-"},
    {"value": 1, "text": "1"},
    {"value": 2, "text": "2"},
    {"value": 3, "text": "3"},
    {"value": 4, "text": "4"},
    {"value": 5, "text": "5"},
    {"value": 6, "text": "6"},
    {"value": 7, "text": "7"},
    {"value": 8, "text": "8"},
    {"value": 9, "text": "9"},
    {"value": 10, "text": "10"},
    {"value": 11, "text": "11"},
    {"value": 12, "text": "12"},
    {"value": 13, "text": "13"},
    {"value": 14, "text": "14"},
    {"value": 15, "text": "15"},
    {"value": 16, "text": "16"},
    {"value": 17, "text": "17"},
    {"value": 18, "text": "18"},
    {"value": 19, "text": "19"},
    {"value": 20, "text": "20"},
];

export function convertLicenceTypeCodeToName(licenceTypeCode) {
  return licenceTypeList.find(licenceType => licenceType.code === licenceTypeCode)?.name ?? '';
}
export default {
  typeList: licenceTypeList,
  countList: licenceUpdateCount
};
